import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiEdit, FiTrash2, FiSearch, FiCalendar, FiPlus, FiX } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, push, onValue, remove, update } from 'firebase/database';

const MeasurementInfo = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    const [viewMode, setViewMode] = useState('list'); // 'list' or 'form'
    const [searchTerm, setSearchTerm] = useState('');
    const [measurements, setMeasurements] = useState([]);

    const initialFormState = {
        name: '',
        englishName: '',
        baseType: 'N/A', // Default
        ratio: ''
    };
    const [formData, setFormData] = useState(initialFormState);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    // Fetch Data
    useEffect(() => {
        const measRef = ref(database, 'Grampanchayat/Panipuravtha/MeasurementInfo');
        onValue(measRef, (snapshot) => {
            const data = snapshot.val();
            const loaded = [];
            if (data) Object.keys(data).forEach(key => loaded.push({ id: key, ...data[key] }));
            setMeasurements(loaded);
        });
    }, []);

    const handleSave = () => {
        if (!formData.name) {
            alert('कृपया मोजमापाचे नाव भरा');
            return;
        }

        const measRef = ref(database, 'Grampanchayat/Panipuravtha/MeasurementInfo');

        if (isEditing && selectedId) {
            const itemRef = ref(database, `Grampanchayat/Panipuravtha/MeasurementInfo/${selectedId}`);
            update(itemRef, formData)
                .then(() => {
                    alert('माहिती यशस्वीरित्या बदलली');
                    resetForm();
                })
                .catch(err => alert(err.message));
        } else {
            push(measRef, formData)
                .then(() => {
                    alert('माहिती यशस्वीरित्या साठवली');
                    resetForm();
                })
                .catch(err => alert(err.message));
        }
    };

    const handleEdit = (item) => {
        setFormData(item);
        setSelectedId(item.id);
        setIsEditing(true);
        setViewMode('form');
    };

    const handleDelete = (id) => {
        if (window.confirm('तुम्ही खात्रीने हे रेकॉर्ड डिलीट करू इच्छिता?')) {
            remove(ref(database, `Grampanchayat/Panipuravtha/MeasurementInfo/${id}`));
        }
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setIsEditing(false);
        setSelectedId(null);
        setViewMode('list');
    };

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6 font-poppins">
            <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg border border-blue-900 overflow-hidden">
                {/* Header */}
                <div className="bg-blue-800 text-white p-4 flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <button onClick={() => viewMode === 'form' ? resetForm() : navigate(-1)} className="bg-white/10 hover:bg-white/20 p-2 rounded-full mr-2"><FiArrowLeft /></button>
                        <h1 className="text-xl font-bold">वस्तु मोजमाप माहिती</h1>
                    </div>
                    {viewMode === 'list' && (
                        <button onClick={() => setViewMode('form')} className="bg-green-600 px-6 py-1.5 rounded font-bold text-sm hover:bg-green-700 transition">नवीन</button>
                    )}
                </div>

                {viewMode === 'list' ? (
                    <div className="p-4">
                         <div className="flex gap-2 mb-4">
                            <input 
                                type="text" 
                                placeholder="वस्तु मोजमापाचे नाव" 
                                className="flex-grow border p-2 rounded border-blue-300 focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button className="bg-green-600 text-white px-6 py-2 rounded font-bold hover:bg-green-700 transition">शोधणे</button>
                         </div>
                         
                         <div className="overflow-x-auto">
                             <table className="w-full text-sm text-center border-collapse">
                                <thead className="bg-[#2c5282] text-white">
                                    <tr>
                                        <th className="px-4 py-3 border-r border-blue-400">क्र.</th>
                                        <th className="px-4 py-3 border-r border-blue-400">मोजमापाचे नाव</th>
                                        <th className="px-4 py-3 border-r border-blue-400">इंग्रजी नाव</th>
                                        <th className="px-4 py-3 border-r border-blue-400">मुळ प्रकार</th>
                                        <th className="px-4 py-3 border-r border-blue-400">प्रमाण</th>
                                        <th className="px-4 py-3">पर्याय</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {measurements.filter(m => m.name.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 ? (
                                        <tr><td colSpan="6" className="p-4 text-gray-500">No records found</td></tr>
                                    ) : (
                                        measurements.filter(m => m.name.toLowerCase().includes(searchTerm.toLowerCase())).map((m, idx) => (
                                            <tr key={m.id} className="hover:bg-blue-50">
                                                <td className="p-3 border-r">{idx + 1}</td>
                                                <td className="p-3 border-r font-medium text-blue-800">{m.name}</td>
                                                <td className="p-3 border-r">{m.englishName}</td>
                                                <td className="p-3 border-r">{m.baseType}</td>
                                                <td className="p-3 border-r">{m.ratio}</td>
                                                <td className="p-3 flex justify-center gap-2">
                                                    <button onClick={() => handleEdit(m)} className="text-blue-600 hover:text-blue-800"><FiEdit size={18} /></button>
                                                    <button onClick={() => handleDelete(m.id)} className="text-red-500 hover:text-red-700"><FiTrash2 size={18} /></button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                             </table>
                         </div>

                        {/* Pagination */}
                        <div className="bg-gradient-to-b from-blue-700 to-blue-900 p-2 mt-4 flex justify-center gap-1 rounded-sm">
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">|&lt;</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&lt;&lt;</button>
                             <button className="px-3 py-1 bg-teal-600 text-white rounded text-xs border border-teal-400 font-bold">1</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&gt;&gt;</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&gt;|</button>
                             <select className="ml-2 py-0.5 px-1 rounded text-xs"><option>5</option></select>
                        </div>
                    </div>
                ) : (
                    <div className="p-8 md:px-20 bg-white">
                        <div className="space-y-6 max-w-3xl mx-auto">
                            
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">मोजमाप क्र.:</label>
                                <div className="md:col-span-3">
                                    <input type="text" value="Auto" disabled className="w-full p-2 border border-gray-300 rounded bg-gray-100" />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">मोजमापाचे नाव:</label>
                                <div className="md:col-span-3">
                                    <input 
                                        type="text" 
                                        placeholder="मोजमापाचे नाव भरा." 
                                        className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                        value={formData.name}
                                        onChange={(e) => setFormData({...formData, name: e.target.value})}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">मोजमाप इंग्रजी नाव:</label>
                                <div className="md:col-span-3">
                                    <input 
                                        type="text" 
                                        placeholder="मोजमाप इंग्रजी नाव भरा." 
                                        className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                        value={formData.englishName}
                                        onChange={(e) => setFormData({...formData, englishName: e.target.value})}
                                    />
                                </div>
                            </div>

                             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">मोजमाप मुळ प्रकार:</label>
                                <div className="md:col-span-3">
                                    <select 
                                        className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        value={formData.baseType}
                                        onChange={(e) => setFormData({...formData, baseType: e.target.value})}
                                    >
                                        <option value="N/A">Select Type</option>
                                        <option value="Unit">Unit (नग)</option>
                                        <option value="Kg">Kg (कि.ग्रॅ)</option>
                                        <option value="Litre">Litre (लिटर)</option>
                                        <option value="Meter">Meter (मीटर)</option>
                                    </select>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">प्रमाण:</label>
                                <div className="md:col-span-3">
                                    <input 
                                        type="text" 
                                        placeholder="मोजमापाचे प्रमाण भरा." 
                                        className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                        value={formData.ratio}
                                        onChange={(e) => setFormData({...formData, ratio: e.target.value})}
                                    />
                                </div>
                            </div>

                            <div className="flex justify-center gap-4 mt-8 pt-4">
                                <button onClick={handleSave} className="bg-green-600 text-white px-8 py-2 rounded font-bold hover:bg-green-700 transition">साठविणे</button>
                                <button onClick={resetForm} className="bg-red-600 text-white px-8 py-2 rounded font-bold hover:bg-red-700 transition">रद्द करणे</button>
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MeasurementInfo;
